import {Separator} from '@chekin/guestapp-ui-kit';
import {useTranslation} from 'react-i18next';
import {AskedQuestion} from './AskedQuestion';
import cn from 'clsx';

type Props = {
  className?: string;
};
export const FrequentlyAskedQuestions = ({className}: Props) => {
  const {t} = useTranslation();

  return (
    <div className={cn(className, 'flex flex-col gap-6')}>
      <h2 className="flex items-center gap-2 text-lg font-semibold">
        {t('esim.my.faq_title')}
      </h2>
      <div className="flex flex-col gap-6 p-6 rounded-2xl bg-[var(--background-secondary)]">
        <AskedQuestion
          question={t('esim.my.faq_activate_question')}
          answer={t('esim.my.faq_activate_answer')}
        />
        <Separator className="w-full bg-[var(--separator-color)]" />
        <AskedQuestion
          question={t('esim.my.faq_immediate_use_question')}
          answer={t('esim.my.faq_immediate_use_answer')}
        />
        <Separator className="w-full bg-[var(--separator-color)]" />
        <AskedQuestion
          question={t('esim.my.faq_run_out_data_question')}
          answer={t('esim.my.faq_run_out_data_answer')}
        />
      </div>
    </div>
  );
};
